// extracted by mini-css-extract-plugin
module.exports = {"badgeCount":"styles_badgeCount__2WnmR"};